module.exports = __webpack_public_path__ + "spinner-out.7437e0b2.png";